import { CostCalculation } from '@forms/CostCalculation'
import { Description } from '@ui/cases/Description'
import { Overview } from '@ui/cases/Overview'
import { ResultSection } from '@ui/cases/ResultSection'
import { TableSection } from '@ui/cases/TableSection'

import { config, configResult, overview, clientImage } from './config'
import { Header } from './Header'
import { Process } from './Process'
import { ProjectExecution } from './ProjectExecution'
import { Solution } from './Solution'
import { Wrapper, ClientImage, ProcessWrapper } from './styles'

export function EducatorsAndTransformingSchools() {
  return (
    <>
      <Header />
      <Wrapper>
        <TableSection
          config={config.technologies}
          marginTop="45px"
          hexagon={false}
          spacing="48px"
        />
        <Overview {...overview} />
        <Description {...config.client} />
        <Solution />
        <Process {...config.process} />
        <ProjectExecution />
        <ProcessWrapper>
          <Process {...config.processSecondPart} />
        </ProcessWrapper>
        <ClientImage {...clientImage} />
        <ResultSection {...configResult} />
      </Wrapper>
      <CostCalculation />
    </>
  )
}
